// extracted by mini-css-extract-plugin
export default {"wrapper":"Confirm_wrapper__VFaVI"};